import styled from "styled-components";

const ProductCategoryTypePageStyled = styled.div`

`;

export default ProductCategoryTypePageStyled;